
import { computed, defineComponent, PropType } from 'vue'
import { useSearchCondition } from '@/utils/useSearchCondition'

export default defineComponent({
  name: 'SearchCondition',

  props: {
    querys: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String as PropType<'hospital' | 'latter'>,
      default: 'hospital'
    },
    hasHeader: {
      type: Boolean,
      default: true
    },
    keywordOnly: {
      type: Boolean,
      default: false
    },
    isSidebar: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const {
      getSearchConditionFromQuery,
      getSearchConditionTag
    } = useSearchCondition()

    const currentConditions = computed(() =>
      getSearchConditionFromQuery(props.querys, props.type)
    )

    const currentConditionsTag = computed(() =>
      getSearchConditionTag(currentConditions.value)
    )

    return {
      currentConditions,
      currentConditionsTag
    }
  }
})
